import { ProjectCode } from '@constants'
import { type AppEnv } from '@dni-types/vite-env'

const wordPressEnvUrlSite = {
  development: 'dev.',
  alpha: 'alpha.',
  beta: 'beta.',
  gamma: 'gamma.',
  production: '',
}

export const getOfficialWebsite = (env: AppEnv): Record<string, string> | null => {
  const envPrefix = wordPressEnvUrlSite[env]
  if (envPrefix === undefined) return null
  return {
    [ProjectCode.DCS]: `https://${envPrefix}dogcatstar.com`,
    [ProjectCode.HM]: `https://${envPrefix}heromamapet.com`,
    [ProjectCode.LM]: `https://${envPrefix}litomon.com`,
    [ProjectCode.MNP]: `https://${envPrefix}ladynpet.com`,
    [ProjectCode.AQUA]: `https://${envPrefix}aquacorners.com`,
    [ProjectCode.PP]: `https://${envPrefix}purialpet.com`,
    [ProjectCode.PM]: `https://${envPrefix}pawswellpet.com`,
    [ProjectCode.YT]: `https://${envPrefix}yummytiger.com`,
  }
}
